import { render, staticRenderFns } from "./sortTop.vue?vue&type=template&id=e3ff1396&"
import script from "./sortTop.vue?vue&type=script&lang=js&"
export * from "./sortTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports